import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const Check = ({ options = {} }) => {

  const { checked = false, description = '' } = options;

  return (
    <Fragment>
      {
        checked &&
        <i className="ic icon-check" />
      }
      {description}
    </Fragment>
  );
};

Check.propTypes = {
  options: PropTypes.shape({
    checked: PropTypes.bool,
    description: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  }),
};

export default Check;



// WEBPACK FOOTER //
// ./js/components/step1/compare/Check.js